var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-divider',{staticClass:"my-6"})
}
var staticRenderFns = []

export { render, staticRenderFns }